// The Vue build version to load with the `import` command
// (runtime-only or standalone) has been set in webpack.base.conf with an alias.
import Vue from 'vue'
import App from './App'
import router from './router'
import store from './store'
import { BootstrapVue, BootstrapVueIcons } from 'bootstrap-vue'
import 'bootstrap/dist/css/bootstrap.css'
import 'bootstrap-vue/dist/bootstrap-vue.css'
import $ from 'jquery'
import axios from 'axios'
import storage from 'good-storage'
import ElementUI from 'element-ui';
import 'element-ui/lib/theme-chalk/index.css';

Vue.use(ElementUI);
Vue.prototype.axios = axios
Vue.use(BootstrapVue)
Vue.use(BootstrapVueIcons)
Vue.config.productionTip = false

Vue.prototype.$bus = new Vue({
  data: {
    eventArr: {}
  },
  methods: {
    on(eventname, callback) {
      // if (this.eventArr.includes(callback)) {
      //   // throw "eventname events already regist!!"
      // } else {
      //   this.eventArr.push(callback)
      //   this.$on(eventname, callback)
      // }
      var have = eventname in this.eventArr
      
      if (have == true) {
        var arr = this.eventArr[eventname]
        arr.push(callback)
      } else {
        this.eventArr[eventname] = [callback]
      }
    },
    emit(eventname, ...arg) {
      // this.$emit(eventname, ...arg)
      var have = eventname in this.eventArr
      
      if (have == true) {
        var arr = this.eventArr[eventname]
        arr.forEach(element => {
          element(...arg)
        }); 
      }
    },
    off(eventname, callback) {
      // this.$off(eventname, callback)
      // var have = eventname in this.eventArr
      
    }
  }
})

/* eslint-disable no-new */
new Vue({
  el: '#app',
  router,
  store,
  components: { App },
  template: '<App/>'
})




// WEBPACK FOOTER //
// ./src/main.js